// extracted by mini-css-extract-plugin
export default {"icons":"GuaranteeCard_icons__+Wp9Y","greyText":"GuaranteeCard_greyText__7Uznk"};